import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import formatCurrency from 'App/helpers/formatCurrency'
import AmountInCurrency from 'App/components/AmountInCurrency'
import InfoIcon from 'react-icons/lib/md/info-outline'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import get from 'lodash/get'

@withGraphQL(
  gql`
    query marketCurrentStats($marketCode: ID!) {
      market(code: $marketCode) {
        code
        name
        lastTrade {
          price
        }
        mainCurrency {
          code
          units
          format
        }
        secondaryCurrency {
          code
          units
          format
          isCrypto
        }
        currentStats(aggregation: d1) {
          open
          close
          volume
          variation
        }
      }
    }
  `,
  {loading: null, options: {pollInterval: 10000}}
)
export default class Indicators extends React.Component {
  static propTypes = {
    market: PropTypes.object,
    me: PropTypes.object
  }
  static fragment = gql`
    fragment testFragment on User {
      _id
      country {
        code
        operateFiat
        referentialCurrency {
          code
        }
      }
      mainCurrency {
        isCrypto
        code
      }
    }
  `
  renderReferentialPrice() {
    const {market, me} = this.props
    const isCryptoMarket = market.secondaryCurrency.isCrypto
    const shouldNotRender = !get(me, 'country') || me.country.operateFiat
    const price = market.lastTrade && market.lastTrade.price

    if (!isCryptoMarket) return
    if (shouldNotRender) return

    // false
    return (
      <div className={styles.indicator}>
        <div className={styles.value}>
          <span className={styles.referentialPrice}>
            {' ~'}
            <AmountInCurrency
              amount={price}
              inCurrencyCode={market.secondaryCurrency.code}
              outCurrencyCode={
                get(me, 'country.referentialCurrency.code') && me.country.referentialCurrency.code
              }
            />
          </span>
        </div>
        <div className={styles.group}>
          <div className={styles.label}>Valor referencial</div>
          <div className={styles.icon}>
            <Tooltip content="Valor referencial calculado a partir de valores de coinmarketcap.com">
              <InfoIcon />
            </Tooltip>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {market} = this.props
    const {currentStats: stats} = market

    if (!stats) return <span />
    const price = market.lastTrade && market.lastTrade.price
    return (
      <div className={styles.container}>
        <div className={styles.indicator}>
          <div className={styles.value}>
            {price ? formatCurrency(price, market.secondaryCurrency, {code: true}) : '-'}
          </div>
          <div className={styles.label}>Última transacción</div>
        </div>
        {this.renderReferentialPrice()}
        <div className={styles.indicator}>
          <div className={styles.value}>{numeral(stats.variation).format('0.00%')}</div>
          <div className={styles.label}>Variación 24h</div>
        </div>
        <div className={styles.indicator}>
          <div className={styles.value}>
            {formatCurrency(stats.volume, market.mainCurrency, {code: true, short: true})}
          </div>
          <div className={styles.label}>Volumen 24h</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Indicators/index.js